import React from "react";
import classNames from "classnames/bind";
import { X, Heart, Trash } from "lucide-react";
import styles from "./WishListModal.module.scss";
import { useFavoritesModalStore } from "../../stores/WishList/useFavoritesModal";
import useWishlistStore from "../../stores/WishList/WishListStore";
import { Link } from "react-router-dom";
import { useLanguageStore } from "../../stores/Language/useLanguageStore";
import useTranslations from "../../hooks/useTranslations";
import { translateProductName } from "../../utils/translateProductName";
import { formatDiscountPercentage } from "../../utils/priceUtils";
import Images from "../../asset/images";

const cx = classNames.bind(styles);

const WishListModal = () => {
  // đóng mở modal
  const { isOpen, close } = useFavoritesModalStore();

  // lấy danh sách wish list
  const { wishlist, removeFromWishlist } = useWishlistStore();

  // format tiền tệ theo ngôn ngữ
  const { formatPrice } = useLanguageStore();
  
  // Lấy translations trước khi kiểm tra isOpen
  const currentTranslations = useTranslations();
  
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      close();
    }
  };

  const handleDeleteItem = async (e, item) => {
    e.preventDefault();
    e.stopPropagation();

    await removeFromWishlist(item.id);
  };

  return (
    <div className={cx("modal-overlay")} onClick={handleOverlayClick}>
      <div className={cx("modal-content")}>
        <div className={cx("modal-header")}>
          <div className={cx("header-left")}>
            <Heart size={20} className={cx("heart-icon")} />
            <h2 className={cx("modal-title")}>
              {currentTranslations?.wishlist?.title}
            </h2>
          </div>
          <button
            className={cx("close-button")}
            onClick={close}
            aria-label="Close favorites modal"
          >
            <X size={20} />
          </button>
        </div>

        <div className={cx("modal-body")}>
          {wishlist.length > 0 ? (
            wishlist.map((item) => (
              <Link
                to={`/product-detail/${item.id}/${item.slug || item.id}`}
                key={item.id}
                className={cx("body-content")}
              >
                <div className={cx("body-image")}>
                  <img
                    src={item.image || Images.ErrorImage}
                    alt={item.name || `Product ${item.id}`}
                    loading="lazy"
                  />
                </div>
                <div className={cx("body-infor")}>
                  <div className={cx("infor")}>
                    <h4 className={cx("title")}>
                      {translateProductName(item.name || `Product ${item.id}`)}
                    </h4>
                    <div className={cx("price-container")}>
                      {item.sale_price && item.sale_price !== item.regular_price ? (
                        <>
                          <p className={cx("sale-price")}>
                            {formatPrice(item.sale_price)}
                          </p>
                          <p className={cx("regular-price", "crossed")}>
                            {formatPrice(item.regular_price)}
                          </p>
                          <span className={cx("discount-badge")}>
                            {formatDiscountPercentage(item.regular_price, item.sale_price)}
                          </span>
                        </>
                      ) : (
                        <p className={cx("price")}>
                          {formatPrice(item.regular_price)}
                        </p>
                      )}
                    </div>
                  </div>
                  <button
                    className={cx("btn-del")}
                    onClick={(e) => handleDeleteItem(e, item)}
                  >
                    <Trash />
                  </button>
                </div>
              </Link>
            ))
          ) : (
            <div className={cx("favorites-empty")}>
              <Heart size={48} className={cx("empty-icon")} />
              <p className={cx("empty-text")}>
                {currentTranslations?.wishlist?.empty_message}
              </p>
              <p className={cx("empty-subtext")}>
                {currentTranslations?.wishlist?.instruction}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WishListModal;
